module.exports = __webpack_public_path__ + "img/ic-white-onde-comer.cd286c29.svg";